import React, {useEffect, useState } from "react";
import { useFormik } from 'formik';
import "../../sass/form/form.scss";
import Datepicker from "../../component/Datepicker/Datepicker";
import {QuillBuilder} from "../../component/RichEditor/RichEditor"
import axios from 'axios';
import './index.scss';
import _ from "lodash";
import { useRef } from "react";
import Slugify from "slugify";

export default (props) => {
    const[basicDataLoaded, setBasicDataLoaded] = useState(false);
    const[cityLoading, setCityLoading] = useState(false);
    const[countries, setCountries] = useState([]);
    const[cities, setCities]        = useState([]);
    const [biographyWYSIWYG, setBiographyWYSIWYG] = useState(false);
    const biographyElement          = useRef(null);
    const [profile, setProfile]     = useState(props.profile);
    const [socmeds, setSocmeds]     = useState(props.socmeds);
    const formik = useFormik({
        initialValues: {
            UserName : ''
            ,UserFirstName : ''
            ,UserMiddleName : ''
            ,UserLastName : ''
            ,Gender : ''
            ,Marital : ''
            ,POB : ''
            ,DOB : ''
            ,CountryISO : ''
            ,City : ''
            ,Phone : ''
            ,UserAddress : ''
            ,Behance    : ''
            ,Twitter    : ''
            ,Instagram  : ''
            ,Deviantart : ''
            ,Website    : ''
        }
        ,onSubmit: values => {

            props.onSubmit.apply(null, [ _.assignIn({}, values, {
                Biography : biographyWYSIWYG.root.innerHTML
            })]);
            
        }
    });

    const LoadCity = (RequestedCountry) => {
        return new Promise((resolve) => {
            
            formik.setFieldValue('CountryISO', RequestedCountry);

            if(formik.values.CountryISO || (typeof RequestedCountry != 'undefined' && RequestedCountry != '' ) )
            {
                setCityLoading(true); 
                
                axios({
                    method: 'post',
                    url: 'https://countriesnow.space/api/v0.1/countries/cities',
                    data: {
                        iso2 : RequestedCountry || formik.values.CountryISO
                    }
                })
                    .then((response) => {
        
                        setCityLoading(false);
        
                        setCities(response.data.data);

                        resolve();
                    })
                    .catch((error) => {
                        setCityLoading(false);
        
                        setCities([]);

                        resolve();
                    } )
            }
            else
            {
                resolve();
            }
        })
    }

    useEffect(() => {


        if(!biographyElement.current)
        {
            return;
        }

        var rte = QuillBuilder(biographyElement.current);

        rte.once('editor-change', () => {
            setBiographyWYSIWYG(rte);
        });

        rte.setText('\n', 'silent');

    }, []);

    useEffect(() => {

        if(!props.profile)
        {
            return;
        }

        if(!biographyWYSIWYG)
        {
            return;
        }


        _.each(props.profile, (value, attribute) => {
            if(value === null)
            {
                value = '';
            }

            if(attribute == 'DOB' && value == '')
            {
                value = '2000-01-01';
            }

            if(attribute == 'UserAbout')
            {
                biographyWYSIWYG.setContents(biographyWYSIWYG.clipboard.convert(value), 'silent');
            }

            formik.setFieldValue(attribute, value);
        });

        _.each(props.socmeds, (value, attribute) => {
            formik.setFieldValue(attribute, value);
        });

        axios.get('https://countriesnow.space/api/v0.1/countries/')
            .then(function(CountriesResponse){
                
                setCountries(_.uniqBy(CountriesResponse.data.data, (country) => {
                    return country.iso2;
                }));

                LoadCity(props.profile.CountryISO).then(() => {setBasicDataLoaded(true)});
            })
            .catch((error) => {

            });

    }, [props.profile, biographyWYSIWYG]);

    return (
        <div id="profile-basic-info-form" className="">
            
            <form className="generic-form mt-5" onSubmit={formik.handleSubmit}>
                <div>
                    <div className="form-group">
                            <label htmlFor="" className="label meta-text">@username*</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="UserName"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={(e) => {
                                        formik.handleBlur(e);

                                        var slug = Slugify(formik.values.UserName, {
                                            lower : true
                                            ,strict : true
                                        });

                                        formik.setFieldValue('UserName', slug);
                                    }}
                                    value={formik.values.UserName}
                                /> : <span className="skeleton"></span> 
                            }
                    </div>
                    <div className="form-group flex-flat">
                        <div>
                            <label htmlFor="" className="label meta-text">First Name*</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="UserFirstName"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.UserFirstName}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div>
                            <label htmlFor="" className="label meta-text">Middle Name</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="UserMiddleName"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.UserMiddleName}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div>
                            <label htmlFor="" className="label meta-text">Last Name</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="UserLastName"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.UserLastName}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                    </div>
                </div>
                <div className="mt-4">
                    <h2 className="text-md bold">Demographic</h2>
                    <div className="text-xs mt-sm leading-text light">
                        Please share your information below. The information is purposed to identify the users based on birth place, birth date, country, city, gender, and marital status.  
                    </div>
                    <hr />
                    <div className="form-group flex-flat">
                        <div>
                            <label htmlFor="" className="label meta-text">Tempat Lahir*</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="POB"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.POB}
                                /> : <span className="skeleton"></span> 
                            }
                            
                        </div>
                        <div>
                            <label htmlFor="" className="label meta-text">Tanggal Lahir*</label>
                            {
                                basicDataLoaded ? 
                                <Datepicker
                                    initialDate={formik.values.DOB ? formik.values.DOB : '1980-01-01'}
                                    onSelect={(values) => {
                                        formik.setFieldValue('DOB', values);
                                    }}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                    </div>
                    
                    <div className="form-group flex-flat">
                        <div>
                            <label htmlFor="" className="label meta-text">Negara*</label>
                            {
                                basicDataLoaded ? 
                                <div className="fancy-select">
                                    <select value={formik.values.CountryISO} name="CountryISO" onChange={(e) => {                                        
                                        LoadCity(e.currentTarget.value)
                                    }}>
                                        <option  name="CountryISO" value="">Select Country</option>
                                        {
                                            countries.map((country, index) => (
                                                <option value={country.iso2} key={country.iso2}>{country.country}</option>
                                            ))
                                        }
                                        <option value="others">Others</option>
                                    </select>
                                </div>
                                : <span className="skeleton"></span> 
                            }
                            
                        </div>
                        <div>
                            <label htmlFor="" className="label meta-text">Kota</label>
                            {
                                basicDataLoaded && !cityLoading ? 
                                    <div className="fancy-select">
                                        <select value={formik.values.City} name="City" onChange={formik.handleChange} >
                                            <option value="">Select City</option>
                                            {
                                                cities.map((city) => (
                                                    <option defaultValue={ formik.values.City == city } value={city} key={city}>{city}</option>
                                                ))
                                            }
                                            <option value="others">Others</option>
                                        </select>
                                    </div>
                                : <span className="skeleton"></span> 
                            }
                        </div>
                    </div>

                    <div className="form-group flex-flat">
                        <div>
                            <label htmlFor="" className="label meta-text">Gender</label>
                            <div className="flex-flat" style={{width : '300px'}}>
                                <label htmlFor="gender-male">
                                    <input type="radio" id="gender-male" name="Gender" checked={formik.values.Gender == 'male'} value="male" onChange={(event) => { formik.setFieldValue('Gender', event.target.value) }} /> Male
                                </label>
                                <label htmlFor="gender-female">
                                    <input type="radio" id="gender-female" name="Gender" checked={formik.values.Gender == 'female'} value="female" onChange={(event) => { formik.setFieldValue('Gender', event.target.value) }} /> Female
                                </label>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="" className="label meta-text">Marital Status</label>
                            <div className="flex-flat" style={{width : '300px'}}>
                                <label htmlFor="marital-male">
                                    <input type="radio" id="marital-male" name="Marital" checked={formik.values.Marital == 'married'} value="married" onChange={(event) => { formik.setFieldValue('Marital', event.target.value) }} /> Married
                                </label>
                                <label htmlFor="marital-female">
                                    <input type="radio" id="marital-female" name="Marital" checked={formik.values.Marital == 'single'} value="single" onChange={(event) => { formik.setFieldValue('Marital', event.target.value) }} /> Single
                                </label>
                            </div>
                        </div>
                    </div>
                    
                </div>
                {
                    typeof props.socmeds != 'undefined' && 
                    <div className="mt-4">
                        <h2 className="text-md bold">Social Medias</h2>
                        <div className="text-xs mt-sm leading-text light">Complete your social media accounts</div>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="" className="label meta-text">Behance</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="Behance"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    defaultValue={formik.values.Behance}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="" className="label meta-text">Twitter</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="Twitter"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    defaultValue={formik.values.Twitter}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="" className="label meta-text">Instagram</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="Instagram"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    defaultValue={formik.values.Instagram}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="" className="label meta-text">Deviantart</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="Deviantart"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    defaultValue={formik.values.Deviantart}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="" className="label meta-text">Website</label>
                            {
                                basicDataLoaded ? <input 
                                    type="text" 
                                    name="Website"
                                    className="form-control text" 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    defaultValue={formik.values.Website}
                                /> : <span className="skeleton"></span> 
                            }
                        </div>
                    </div>
                }
                <div className="mt-4" style={{ display : 'none'}}>
                    <h2 className="text-md bold">About</h2>
                    <div className="text-xs mt-sm leading-text light">Give a few sentences that can describe yourself well. A complete biography will make it easier for you to be accepted in an initiative</div>
                    <hr />
                    <div ref={biographyElement} id="user-biography"></div>
                </div>
                {
                    basicDataLoaded &&
                    <div className=" form-group mt-5">
                        <div className="text-right">
                            <button className="btn btn-orange" type="submit">{props.submitButtonText || 'Next'}</button>
                        </div>
                    </div>

                }
            </form>
        </div>
    )
}